"use client";

import { motion } from "framer-motion";
import { ReactNode, forwardRef } from "react";

interface ScrollableFlowScreenProps {
  children: ReactNode;
  onViewportEnter?: () => void;
  className?: string;
  compact?: boolean;
}

export const ScrollableFlowScreen = forwardRef<HTMLDivElement, ScrollableFlowScreenProps>(
  ({ children, onViewportEnter, className = "", compact = false }, ref) => {
    return (
      <motion.div
        ref={ref}
        className={`${compact ? 'py-10' : 'min-h-screen'} flex flex-col items-center justify-center gap-8 ${compact ? 'px-10' : 'p-10 md:p-20'} ${className}`}
        onViewportEnter={onViewportEnter}
        viewport={{ margin: "-40%" }}
      >
        {children}
      </motion.div>
    );
  }
);

ScrollableFlowScreen.displayName = "ScrollableFlowScreen";